// extracted by mini-css-extract-plugin
export default {"haibao":"index_haibao_0xUxU","bgimage":"index_bgimage_0Gkwr","qrcode":"index_qrcode_lCnp9"};